import script from "./tab.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab.vue?vue&type=script&setup=true&lang=ts"

import "./tab.vue?vue&type=style&index=0&id=08cca76c&lang=css"

const __exports__ = script;

export default __exports__